module.exports = __webpack_public_path__ + "f2381ee3b6e425b7b0c49e3f1c033608.png";